import { Component } from '@angular/core';
import {ConfirmationService, MenuItem} from "primeng/api";
import {AuthService} from "./services/auth.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [ConfirmationService]
})
export class AppComponent {
  items: MenuItem[];
  timeLeft: string = "0s.";
  timer: any = null;
  sessionWarn : boolean = false;
  displaySessionPopup : boolean = false;
  sessionExpired: boolean = false;

  constructor(
    public authService: AuthService,
    public router: Router
  ) {
    this.items = [
      {
        label: 'Wyloguj',
        icon: 'pi pi-sign-out',
        command: () => this.logout(),
      },
    ];
  }

  ngOnInit() {
    this.authService.loginChanged.subscribe(
      (logged) => { this.loginChanged(logged); }
    );
    this.timer = this.updateTimer();
  }

  loginChanged(logged: boolean) {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    if (logged) {
      this.timer = this.updateTimer();
      this.sessionExpired = false;
    } else
      this.sessionExpired = true;
  }

  logout() {
    this.authService.logout().subscribe(
      () => {
        this.authService.clearData();
        this.router.navigate(['/home']);
      },
      () => {
        this.authService.clearData();
        this.router.navigate(['/home']);
      }
    )
  }

  updateTimer() {
    let timeout = 60000;
    if (this.authService.isAuthenticated()) {
      let deadline = this.authService.getJwtData()?.exp;
      if (deadline) {
        let secondsLeft = deadline - Math.floor(Date.now() / 1000);
        let minutesLeft = Math.floor(secondsLeft / 60);
        if (minutesLeft < 0) {
          this.timeLeft = "0s.";
          this.sessionExpired = true;
        } else if (minutesLeft < 2) {
          if (secondsLeft <= 60) {
            this.timeLeft = secondsLeft + "s.";
          } else
            this.timeLeft = minutesLeft + "min.";
          timeout = 1000;
        } else {
          this.timeLeft = minutesLeft + "min.";
        }
        this.sessionWarn = minutesLeft <= 5;
        this.displaySessionPopup = minutesLeft <= 1;
      }
    }
    setTimeout(() => {this.updateTimer();}, timeout);
  }

  extendSession() {
    this.authService.restore().subscribe();
  }

  onDialogClosed() {
    this.displaySessionPopup = false;
    if (this.sessionExpired) {
      this.authService.clearData();
      this.router.navigate(['/home']);
    } else
      this.extendSession();
  }
}
